import * as React from "react";
import {VeboxTreeView} from "../VeboxTreeView";

export interface VeboxTreeViewItemsGroupProps {
    value?: any | any[];
}

export const VeboxTreeViewItemsGroup: React.FC<VeboxTreeViewItemsGroupProps & React.HTMLAttributes<any>> = ({
                                                                                                                className,
                                                                                                                children,
                                                                                                                value,
                                                                                                                ...rest
                                                                                                            }) => {

    return (
        <VeboxTreeView
            {...rest}
            className={className}
            onChange={undefined}
        >
            {React.Children.toArray(children)
                .filter(Boolean)
                .map((c: any) => React.cloneElement(
                    c,
                    {
                        ...(c ?? {}).props,
                        parentValue: value,
                    }
                ))
            }
        </VeboxTreeView>
    );
}